export const en = {
    emptyMessage: 'Enter value',
    integerMessage: 'The value must be an integer',
    nanMessage: 'The value must be an integer',
    tooBig: 'The value is too big. It must be in the range from {minLimit} to {maxLimit}',
    tooLittle: 'The value is too small. It must be in the range from {minLimit} to {maxLimit}'
};
